module.exports = __webpack_public_path__ + "fb9e9770859970e9597b57cc28774445.svg";